<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
    <el-form ref="update" :model="update" label-width="80px" class="backborder1 demo-form-inline" size="medium">
      <el-form-item label="旧密码" style="width:100%">
        <el-input v-model="update.oldpass" type="password" style="width:30%"></el-input>
      </el-form-item>
      <el-form-item label="新密码" style="width:100%">
        <el-input v-model="update.password" type="password" style="width:30%"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" style="width:100%">
        <el-input v-model="update.password2" type="password" style="width:30%"></el-input>
      </el-form-item>
      <el-form-item style="width:100%">
        <el-button type="primary" @click="updateSave" :loading="updateLoading">立即修改</el-button>
      </el-form-item>
    </el-form>
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Password/index",
      transitionshow:true,
      updateLoading:false,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        oldpass:'',
        password:'',
        password2:''
      }
    }
  },
  mounted(){
    
  },
  methods:{
    //重置表单
    reset() {
        this.$refs.update.resetFields();
    },
    //更新
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateLoading=false;
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/config/Password.vue